/* @flow */
import * as React from "react";
import Tappable, { simpleActiveBackgroundColor } from "nx-components/Tappable";
import TileBody from "nexia_mobile/components/Tiles/TileBody";
import prefixStyles from "nx-components/utils/prefixStyles";
import { history } from "nexia_mobile/history";
import { getTransitionPromise } from "nexia_mobile/components/Routing/HistoryPageTransitionController";
import { IconBuilding } from "nx-components/Icons";
import Location from "nexia_mobile/models/location";

const styles = prefixStyles({
  iconStyle: {
    fontSize: "6em",
  },
});

type Props = {
  model: Location,
  tileStyles: {
    contents: Object,
    title: Object,
  },
};

export default class BuildingTile extends React.Component<Props> {
  _handleTap = () => {
    const { model } = this.props;
    history.push("/app/buildings/details", { building: model });
  };

  render() {
    const { model, tileStyles } = this.props;

    let buildingName = model.get("name");

    return (
      <Tappable onTap={this._handleTap} holdActiveUntil={getTransitionPromise}>
        {({ active, tapTargetRefHandler }) => (
          <div
            data-component-name="BuildingTile"
            className="tile-contents"
            style={{
              ...tileStyles.contents,
              backgroundColor: simpleActiveBackgroundColor(active),
            }}
          >
            <TileBody innerRef={tapTargetRefHandler}>
              <IconBuilding style={styles.iconStyle} />
              <div className="tile-title" style={tileStyles.title}>
                {buildingName}
              </div>
            </TileBody>
          </div>
        )}
      </Tappable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tiles/BuildingTile.jsx